module.exports = __webpack_public_path__ + "img/base_activites_ping_pong.dc960d49.svg";